import React from "react";
import { useStateContext } from "../../../context/ContextProvider";
import useFadeInOnScroll from "../../../components/Effects/FadeInOnScroll";

import img1 from "../../../assets/images/services/2-1.png";
import img2 from "../../../assets/images/services/2-2.png";
import img3 from "../../../assets/images/services/2-3.png";
import img4 from "../../../assets/images/services/2-4.png";
import img5 from "../../../assets/images/services/2-5.png";
import img6 from "../../../assets/images/services/2-6.png";

const DigitalMarketing = () => {

    const {
        isMobile
    } = useStateContext();

    useFadeInOnScroll();

    const cards = [
        {
            title: "Brand Awareness: Building brand awareness is crucial for any business looking to establish a strong presence in the market",
            image: img1,
        },
        {
            title: "Content Marketing: Content marketing involves creating valuable, relevant, and consistent content to attract and retain a clearly defined audience",
            image: img2,
        },
        {
            title: "Social Media Marketing: Platforms like Facebook, Instagram, Twitter, and LinkedIn offer unparalleled opportunities for businesses to connect directly with their target audience",
            image: img3,
        },
        {
            title: "Email Marketing: Email remains one of the most effective ways to communicate with existing and prospective customers",
            image: img4,
        },
        {
            title: "Google Ads & Display Ads: Google Ads  is a powerful tool for driving traffic to your website by placing ads at the top of search engine results pages (SERPs)",
            image: img5,
        },
        {
            title: "Local Ads: For businesses targeting specific geographic regions, local ads play an essential role ",
            image: img6,
        }
    ];

    const prolist = [
        {
            text: "Key Components of Digital Marketing",
            active: true
        },
    ];
    return (
        <>
            <div className="w-full relative py-5 my-5 flex flex-col gap-5">
                <div className="h-[50px]"></div>
                {/* 1 */}
                <div className="relative padding-container w-full my-5 py-5 text-start z-1 flex flex-col gap-1">
                    <div className="fade-element text:4xl md:text-5xl lg:text-6xl capitalize font-bold">
                        Understanding Digital Marketing: A Comprehensive Overview
                    </div>
                    <div className="w-full flex justify-end">
                        <div className="fade-element lg:max-w-[50%] min-w-[300px] text-xs md:text-sm text-justify text-[var(--l-gray)] mb-5">
                            Digital marketing refers to the promotion of products, services, or brands through various online channels. It encompasses a wide range of strategies and tactics designed to engage audiences, generate leads, and drive business growth. At its core, digital marketing is about connecting with the right audience at the right time, using data-driven insights and innovative tools
                        </div>
                    </div>
                </div>
                {/* 2 */}
                <div className="relative padding-container w-full my-5 py-5 text-center z-1">
                    <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4">
                        {prolist?.map((list, index) => (
                            <div
                                key={index}
                                className={`fade-element w-full border capitalize rounded-full font-bold p-3 ${list?.active && "bg-white text-black"}`}
                            >
                                {list?.text}
                            </div>
                        ))}
                    </div>
                </div>

                <div className="relative padding-container w-full my-5 py-5 text-center z-1">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
                        {cards?.map((card, index) => (
                            <div
                                key={index}
                                className={`fade-element relative w-full h-[350px] border border-[5px] rounded-[30px] capitalize overflow-hidden flex flex-col justify-end`}
                                style={{
                                    backgroundImage: `url("${card?.image}")`, backgroundSize: "cover", backgroundPosition: "center"
                                }}
                            >
                                <div className="absolute w-full h-full rounded-[30px]" style={{ background: "linear-gradient(180deg, #FFFFFF 0%, #000000 100%)", mixBlendMode: "multiply" }}></div>
                                <div className="absolute w-full h-full rounded-[30px] flex flex-col p-4 justify-end" style={{ zIndex: 1 }}>
                                    <div className="font-bold capitalize">{card?.title}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                {/* 4 */}
                <div className="relative padding-container w-full my-5 py-5 text-start z-1 flex flex-col gap-4 text-base">
                    <div className="fade-element text:2xl md:text-3xl lg:text-4xl capitalize font-bold">
                        Strategic Planning in Digital Marketing
                    </div>
                    <div className="fade-element">
                        A successful digital marketing strategy requires thorough market research and understanding of your target audience . Conducting a competitor analysis helps identify gaps in the market and highlights areas where you can differentiate yourself from others
                    </div>
                    <div className="fade-element">
                        Furthermore, adopting an omnichannel marketing approach ensures consistency across all touchpoints, enhancing the overall customer experience
                    </div>
                    <div className="fade-element">
                        Performance marketing focuses on measurable outcomes such as clicks, conversions, and return on investment (ROI). Utilizing analytics tools, businesses can track campaign performance and make informed decisions to optimize results over time.
                    </div>
                </div>
                {/* 5 */}
                <div className="relative padding-container w-full my-5 py-5 z-1 flex flex-col gap-4">
                    <div className="fade-element text:2xl md:text-3xl lg:text-4xl capitalize font-bold text-end">
                        Why Choose Digital Marketing Services?
                    </div>
                    <div className="w-full flex justify-center">
                        <div className="fade-element lg:max-w-[50%] min-w-[300px] text-xs md:text-sm text-justify text-[var(--l-gray)] mb-5">
                            Professional digital marketing services offer expertise in planning, executing, and analyzing campaigns tailored to your business goals. Whether it’s improving website traffic, generating high-quality leads, or boosting brand awareness, these experts bring years of experience and cutting-edge technologies to the table. With the ever-evolving landscape of internet marketing, staying updated on trends and best practices becomes vital for long-term success
                        </div>
                    </div>
                </div>
                {/* 6 */}
                <div className="relative padding-container w-full my-5 py-5 z-1 flex flex-col gap-4">
                    <div className="fade-element text:2xl md:text-3xl lg:text-4xl capitalize font-bold text-start">
                        Do you want to strengthen your brand's presence on social media?
                    </div>
                    <div className="w-full flex justify-center">
                        <div className="fade-element lg:max-w-[50%] min-w-[300px] text-xs md:text-sm text-justify text-[var(--l-gray)] mb-5">
                            Contact us today to discuss how DO DEAL can transform your ideas into impactful content that drives real results!
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DigitalMarketing;